<template>
  <div class="bg-[#23242A] text-white app-header custom p-3" id="content_screen">
    <div v-if="vg_selectedLocation.id">
      <div :class="'px-3 pt-3 flex content-main ' + (action.component ? ' half-it gap-5' : 'gap-5')">
        <div class="custom-full customer-list">
          <div class="bg-[#2B2C32] rounded-lg max-w-full">
            <List :changeComponent="addUpdate" :selectedCallback="selectedItem" :clearComponent="clearComponent" :iscomponentactive="action.component ? true : false"/>
          </div>
        </div>
    
        <div class="w-full hidden-component custom-right" v-if="action.component" >
          <component :is="action.component" :item="action.data" :clearComponent="clearComponent"></component>
        </div>

      </div>
    </div>

    <div class="flex lg:flex-row flex-col bg-[#2B2C32] rounded-xl" v-else> 
        <div class="w-full">
          <div class="bg-[#2B2C32] rounded-lg px-8 py-[16px]">
            <p  class="text-center text-theme-red">Please select a location from the top left corner.</p>
          </div>
        </div>
    </div>

  </div>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import List from '@/views/Membership/Customer/List.vue';
import Add from '@/views/Membership/Customer/Add.vue';
import Update from '@/views/Membership/Customer/Update.vue';
import Helpers from '@/helpers';

  export default defineComponent({
  name: "ProductSales",
  components: {
    List,
    Add,
    Update,
  },

  setup() {
    const action = ref<object>({
      component: '',
      data: {},
    });
    return {
      action,
    };
  },

   watch: {
    'vg_selectedLocation'(val) {
      this.clearComponent();
    },
  },

  computed: {

    can_edit_customer_details_in_admin() {
      return Helpers.getMyPermission('can_edit_customer_details_in_admin')
    },

    ...mapGetters({
     vg_selectedLocation: 'location/selected'
    }),
  },

  mounted() {
    this.emitter.on("reset-membership-customer-component", data => {
      this.clearComponent();
    });
  },

  beforeDestroy() {
    this.emitter.off('reset-membership-customer-component', () => {});
    this.emitter.off('refresh-membership-customer-list', () => {});
  },
 
  methods: {
    /**
     * Clear action
     */
    clearComponent() {
      this.action = {
        component: '',
        data: {},
      };
      let activeItem = document.getElementsByClassName('active-row');
      if(activeItem.length > 0){
        activeItem[0].classList.remove("active-row");
      }
    },

    /**
     * Change add / update component
     */
    addUpdate(val: any) {
      this.action = val;
    },

    /**
     * Capture selected item
     */
    selectedItem(item) {
      this.addUpdate({
        component: 'Update', 
        data: item
      })
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>